import { AnyAction } from "redux";
import {
    SELECTED_VERSIONS_UPDATED,
    VERSIONS_FETCHED,
    APP_LIST,
    SELECTED_APP,
    COUNTRIES_FETCHED,
    SELECTED_COUNTRIES_UPDATED,
    START_DATE_FETCHED,
    SELECTED_DATE_RANGE_UPDATED,
    DEVELOPER_COUNTRY_DISTRIBUTION,
    RESET_DEV_ANALYTICS_FILTERS,
    CHART_DATA_FETCHED,
} from "../actions/dev_analytics";

const initialState = {
    appsList: [],
    totalInstalls: 0,
    selectedApp: null,
    versions: [],
    selectedVersions: null,
    countries: [],
    selectedCountries: null,
    startDateForSelectedApp: null,
    selectedDateRange: null,
    selectedPreDefinedDateRange: "Last 30 Days",
    chartSection: { data: [] },
    chartSectionView: null,
};

interface Version {
    id: string;
    versionName: string;
}

interface AppInstall {
    app_id: string;
    installs_per_app: number;
    name: string;
}
interface Country {
    id: string;
    name: string;
}

const formatVersions = (versions: Array<Version>) =>
    versions.map((version) => ({
        id: version.id,
        name: version.versionName,
    }));

const formatAppInstalls = (apps: Array<AppInstall>) =>
    apps.map((app) => ({
        id: app.app_id,
        installsCount: app.installs_per_app,
        name: app.name,
    }));

const formatCountries = (countries: Array<Country>) =>
    countries.map((country) => ({
        id: country.id,
        name: country.name,
    }));

const devAnalyticsReducer = (state = initialState, action: AnyAction) => {
    const { type, payload } = action;

    // eslint-disable-next-line no-extra-boolean-cast
    if (!!state.selectedDateRange) {
        console.log("state in reducer" + JSON.stringify(state.selectedDateRange));
    }

    switch (type) {
        case APP_LIST: {
            const formatedAppInstalls = formatAppInstalls(payload.apps);
            return {
                ...state,
                appsList: formatedAppInstalls,
                totalInstalls: payload.total_app_install_count,
                selectedApp: payload.apps?.length ? formatedAppInstalls[0] : null,
            };
        }
        case VERSIONS_FETCHED:
            return { ...state, versions: formatVersions(payload.data.data) };
        case SELECTED_VERSIONS_UPDATED:
            return { ...state, selectedVersions: payload };
        case SELECTED_APP:
            return { ...state, selectedApp: payload };
        case COUNTRIES_FETCHED:
            return { ...state, countries: formatCountries(payload.data.data) };
        case SELECTED_COUNTRIES_UPDATED:
            return { ...state, selectedCountries: payload };
        case START_DATE_FETCHED:
            return { ...state, startDateForSelectedApp: new Date(payload.data.data.createdAt) };
        case SELECTED_DATE_RANGE_UPDATED:
            return {
                ...state,
                selectedDateRange: payload.newSelectedDateRange,
                selectedPreDefinedDateRange: payload.selectedPreDefinedDateRange,
            };
        case DEVELOPER_COUNTRY_DISTRIBUTION:
            return { ...state, developerCountryDistribution: payload.data.data };
        case RESET_DEV_ANALYTICS_FILTERS:
            return {
                ...state,
                versions: initialState.versions,
                selectedVersions: initialState.selectedVersions,
                countries: initialState.countries,
                selectedCountries: initialState.selectedCountries,
                startDateForSelectedApp: initialState.startDateForSelectedApp,
                selectedDateRange: initialState.selectedDateRange,
                selectedPreDefinedDateRange: initialState.selectedPreDefinedDateRange,
            };
        case CHART_DATA_FETCHED:
            return {
                ...state,
                chartSection: payload.data,
                chartSectionView: payload?.data?.other?.view,
            };
        default:
            return state;
    }
};

export default devAnalyticsReducer;
